import { render } from "./SelectDistributorMapping.vue?vue&type=template&id=71f2f250"
import script from "./SelectDistributorMapping.vue?vue&type=script&lang=js"
export * from "./SelectDistributorMapping.vue?vue&type=script&lang=js"
script.render = render

export default script